<template lang="pug">
.sponsor-details.modal-wrapper
    .modal-header
        a.close(@click="$emit('close')")
        picture
            img(v-if="logo" :srcset="`${logo} 2x`" :alt="title" @error="logo = null")
            sponsor-placeholder-image(v-else)

        .details
            .title {{ title }}

        .level(v-if="sponsor.level" :style="{ color: sponsor.level.text_color, 'background-color': sponsor.level.level_color }")
            | {{ sponsorLevel }}

        .meta(v-if="showMeta" :class="{ 'has-bio': hasBio }")
            span.location(v-if="sponsor.location") {{ sponsor.location }}
            a.website(v-if="sponsor.website" :href="sponsor.website" target="_blank" rel="noopener noreferrer") {{ formatedWebsite }}
            a.email(v-if="sponsor.email" :href="`mailto:${sponsor.email}`") {{ sponsor.email }}

    .modal-body
        .desc(v-if="description" v-html="description")

    .modal-footer
</template>
<script>
// Mixins
import translatable from '@/components/registration/sections/translatable.mixin.js';

// Components
import SponsorPlaceholderImage from '@/components/registration/sections/SponsorPlaceholderImage.vue';

export default {
    name: 'SponsorDetails',

    mixins: [translatable],

    components: { SponsorPlaceholderImage },

    props: {
        sponsor: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            logo: this.sponsor.logo,
            translatable_object: this.sponsor
        }
    },

    computed: {
        sponsorLevel() {
            return this.getT9Label('level_name', this.sponsor.level)
        },

        location() {
            return this.getT9Label('location');
        },

        website() {
            return this.getT9Label('website');
        },

        formatedWebsite() {
            return this.website.replace(/^http(s)?:\/\//, '');
        },

        email() {
            return this.getT9Label('email');
        },

        description() {
            return this.hasFpI18n(this.sponsor) ? this.getT9Label('content') : this.getT9Label('description');
        },

        hasBio() {
            return Boolean(this.description?.trim().length);
        },

        showMeta() {
            return Boolean(this.location || this.website || this.email || this.description);
        }
    }
};
</script>
